import hexRgb from 'hex-rgb';

import { TagColors } from 'constants/colors';

export const hexToRgb = (hex: string, alpha: number) =>
  `rgba(${hexRgb(hex, { format: 'array' }).slice(0, 3).toString()},${alpha})`;

/**
 * Lightens or darkens a color
 * @param col the color to lighten or darken
 * @param amt the amount to lighten or darken (positives values ligthen, negative values darken)
 * @returns the new color
 */
export const LightenDarkenColor = (col: string, amt: number) => {
  let usePound = false;
  if (col[0] === '#') {
    col = col.slice(1);
    usePound = true;
  }
  const num = parseInt(col, 16);

  let r = (num >> 16) + amt;
  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  let b = ((num >> 8) & 0x00ff) + amt;
  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  let g = (num & 0x0000ff) + amt;
  if (g > 255) g = 255;
  else if (g < 0) g = 0;
  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
};

/**
 * Gets the main Color corresponding to the tag svg
 * @param {String} tagSortOrder the tag.sort_order unique to tagId
 */
export const getTagColor = (tagSortOrder: number) => {
  switch (tagSortOrder) {
    case 10:
      return TagColors._10;
    case 20:
      return TagColors._20;
    case 30:
      return TagColors._30;
    case 40:
      return TagColors._40;
    case 50:
      return TagColors._50;
    case 60:
      return TagColors._60;
    case 70:
      return TagColors._70;
    case 80:
      return TagColors._80;
    case 90:
      return TagColors._90;
    case 100:
      return TagColors._100;
    case 110:
      return TagColors._110;
    case 120:
      return TagColors._120;
    case 130:
      return TagColors._130;
    case 140:
      return TagColors._140;
    case 150:
      return TagColors._150;
    case 160:
      return TagColors._160;
    case 170:
      return TagColors._170;
    case 180:
      return TagColors._180;
    case 190:
      return TagColors._190;
    case 200:
      return TagColors._200;
  }
};
